import React, { useState } from 'react';
import BlackButton from '../Utils/BlackButton';
import GrayButton from '../Utils/GrayButton';

const ModalAddCategory = ({ isOpen, onClose, onSave }) => {
  const [formData, setFormData] = useState({ name: '', img_item: '' });

  if (!isOpen) return null;

  const handleSave = () => {
    if (!formData.name.trim()) return;
    onSave(formData);
    setFormData({ name: '', img_item: '' });
  };

  const handleClose = () => {
    setFormData({ name: '', img_item: '' });
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-96">
        <h2 className="text-xl font-bold mb-4">Agregar Categoría</h2>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Nombre de la categoría
          </label>
          <input
            type="text"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4"
            placeholder="Ingresa el nombre de la categoría"
          />
          <label className="block text-sm font-medium text-gray-700 mb-2">
            URL de la imagen (Opcional)
          </label>
          <input
            type="text"
            value={formData.img_item}
            onChange={(e) => setFormData({ ...formData, img_item: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="https://ejemplo.com/imagen.jpg"
          />
        </div>
        <div className="flex justify-end space-x-2">
          <GrayButton onClick={handleClose}>
            Cancelar
          </GrayButton>
          <BlackButton onClick={handleSave}>
            Guardar
          </BlackButton>
        </div>
      </div>
    </div>
  );
};

export default ModalAddCategory;
